import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { sortBy } from 'lodash';
import Select from 'react-select';

import ApiServiceServerless from '../../../xhr_libs';
import SmallerLoader from '../../../components/SmallerLoader';

export default function SelectPlugLoadedAccountModal(props) {
  const {
    show,
    onHide,
    providerAccounts,
    organizationId,
    setLoadedAccount,
    setStatements,
  } = props;

  const [accountId, setAccountId] = useState('');
  const [accountNumber, setAccountNumber] = useState('');

  const [statementCount, setStatementCount] = useState(12);

  const [localAccounts, setLocalAccounts] = useState([]);

  const [selectOptions, setSelectOptions] = useState([]);

  const [loadedStatements, setLoadedStatements] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setLocalAccounts(
      providerAccounts.filter((acc) => acc.providerClassification === 'PRIMARY')
    );
  }, [providerAccounts]);

  useEffect(() => {
    let select_options = []

    sortBy(localAccounts, ['accountNumber']).forEach((account) => {
      select_options.push({ 'value': account.id, 'label': account.accountNumber })
    })
    setSelectOptions(select_options)

  }, [localAccounts])

  useEffect(() => {
    const acc = localAccounts.find((acc) => acc.id === accountId);
    if (acc) {
      setAccountNumber(acc.accountNumber);
    }
  }, [accountId, localAccounts]);

  const handleGetStatementOptions = () => {
    setIsLoading(true);
    setLoadedStatements(0);
    getStatementOptions([], 0);
  };

  const getStatementOptions = (statements, page) => {
    setIsLoading(true);

    ApiServiceServerless.get(
      `custom_templates/statements/${accountId}/${page}`,
      {
        authorization_id: organizationId,
      }
    )
      .then((res) => {
        statements = [...statements, ...res.data.statements];
        if (page + 1 > res.data.totalPages || page + 1 >= statementCount) {
          setStatements(statements);
          setLoadedAccount(accountNumber);
          setIsLoading(false);
          onHide();
        } else {
          setLoadedStatements((prev) => prev + 1);
          getStatementOptions(statements, page + 1);
        }
      })
      .catch(() => {
        setIsLoading(false);
        onHide();
      });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton={!isLoading}>
        Get account statements
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={10}>
            <Form.Group>
              <Form.Label>Account Number</Form.Label>
              <Select
                defaultValue={{ value: '', 'label': '-' }}
                onChange={(option) => { setAccountId(option.value) }}
                options={selectOptions}
                classNamePrefix='et-react-select'
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Statements Count</Form.Label>
              <Form.Control
                onChange={(e) => setStatementCount(parseInt(e.target.value))}
                value={statementCount}
              />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='primary'
          onClick={() => handleGetStatementOptions()}
          disabled={!accountId || isLoading}
        >
          {isLoading && (
            <>
              {`${loadedStatements}/${statementCount}  `}
              <SmallerLoader text={'Loading...'} />
            </>
          )}
          {!isLoading && <> Get data</>}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
